export const CACHE_KEY_LIST_TEMPLATES = 'templates';
export const CACHE_KEY_TEMPLATES = 'templates-one';
export const ROUTE_PATH_TEMPLATES = '/templates/register-type/register';
export const TRANSLATION_PREFIX_TEMPLATES = 'templates';

